<!--
 * @Author: 317473294@qq.com
 * @Date: 2022-07-19 11:03:38
 * @LastEditTime: 2024-09-29 22:28:54
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/components/word/zdzy-pagination.vue
-->
<template>
    <div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="pages.page" :page-sizes="[5,10,25,20]" layout="total,sizes,prev, pager, next,jumper" :total="total">
        </el-pagination>
    </div>
</template>
<script>
    export default {
        name: "wordPagination",
        data() {
            return {
                total:0,
                // pageNum:[5,10,25,20],
                pages:{
                    limit:5,//每页显示几条 
                    page:1,//当前页数
                }
                
            }
        },
 
        methods: {
            init(pageLimit){
                // //console.log()
                //console.log("父传递过来的数据：",pageLimit)
                this.total=pageLimit.total
           
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.pages.limit=val
                this.$emit('addlistenerData', this.pages);//需要显示的数据
            },
            handleCurrentChange(val) {
                this.pages.page=val
                //console.log(`当前页:`,this.pages);
                this.$emit('addlistenerData', this.pages);//需要显示的数据
              
            },
        },

    }
</script>
<style scoped>
>>>.el-pagination {
  height: .5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/word/zdzy-pagination.vue